var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M27.848 111.329c0 4.924-1.946 10.031-6.023 12.129-1.719.884-7.164.542-9.227.542C5.64 124 0 119.662 0 112.667V67.733a2.4 2.4 0 0 1 2.4-2.4h18.556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M24.691.89h95.161a4.8 4.8 0 0 1 4.8 4.8V119.2a4.8 4.8 0 0 1-4.8 4.8h-99.96V5.69a4.8 4.8 0 0 1 4.8-4.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 65)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1.2,
    d: "M27.248 111.373l-6.808-45.44H2.4a1.8 1.8 0 0 0-1.8 1.8v44.934c0 6.388 5.057 10.733 11.998 10.733.368 0 .386 0 1.773.033 1.145.026 1.904.037 2.698.03 2.24-.018 3.801-.189 4.481-.539 3.567-1.835 5.686-6.4 5.698-11.551z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 65)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1.2,
    d: "M20.491 123.4h99.361a4.2 4.2 0 0 0 4.2-4.2V5.69a4.2 4.2 0 0 0-4.2-4.2h-95.16a4.2 4.2 0 0 0-4.2 4.2V123.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M107.5 76.557h38.457V109H107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    strokeWidth: 1.2,
    d: "M155.24 81.19h35.804M155.24 90.333h35.804M155.24 98.333h35.804M155.24 107.333h35.804M107.5 121h83.013M107.5 130.333h82.218M107.5 139.333h75.587M107.5 148.333h68.957M107.5 157.333h63.652M107.5 166.333h59.674M107.5 175.333h35.141"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#64808C",
    d: "M214.938 108.18l-15.505 19.135a1.015 1.015 0 0 0-.233.743c.026.265.161.518.369.685.207.168.483.247.748.217a1.02 1.02 0 0 0 .68-.382l15.502-19.132c1.933-2.37 5.431-2.736 7.801-.822l7.532 6.094-4.609 5.678-6.667-5.378a1.02 1.02 0 0 0-.738-.218 1.02 1.02 0 0 0-.677.367l-7.711 9.49-38.536 47.487c-.078.097-.139.21-.177.328l-3.939 12.374a1.009 1.009 0 0 0 .323 1.081 1.014 1.014 0 0 0 1.127.098l11.389-6.365c.11-.062.21-.145.29-.244l45.079-55.55 1.16-1.419 5.882-7.247c.166-.204.247-.475.22-.736a1.015 1.015 0 0 0-.367-.675l-8.314-6.725a7.535 7.535 0 0 0-5.54-1.626 7.567 7.567 0 0 0-5.089 2.741zm5.133 9.03l5.883 4.744-.526.644-.003.003-2.058 2.536-5.882-4.745 2.586-3.183zm-3.854 4.742l5.884 4.745-2.589 3.19-5.881-4.753 2.586-3.182zm-3.853 4.743l5.882 4.752-37.78 46.557-9 5.029 3.111-9.773 37.787-46.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M220.071 117.21l5.883 4.744-.526.644-.003.003-2.058 2.536-5.882-4.745 2.586-3.183zM216.217 121.952l5.884 4.745-2.589 3.19-5.881-4.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M212.364 126.695l5.882 4.752-37.78 46.557-9 5.029 3.111-9.773z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    strokeWidth: 1.2,
    d: "M173.817 173.643l6.745 5.449"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsEmpty);
export default __webpack_public_path__ + "static/media/blogs-empty.355c2f8db95ea5506fe06cd484a2e277.svg";
export { ForwardRef as ReactComponent };